export const LOCALE_STORAGE_KEY = 'nuar-temp-locale';
